import Vue from "vue";
import App from "./App.vue";

import "@/request/request";
import router from "./router";
import store from "./store";
import "./router/permission";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

import "@/assets/css/publicLayout.scss";
import "@/utils/contextmenu.js";

Vue.use(ElementUI);

Vue.config.productionTip = false;

// 创建一个事件总线
Vue.prototype.$bus = new Vue();


new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
